import { render } from "./PricingPlans.vue?vue&type=template&id=e76ceda8&scoped=true"
import script from "./PricingPlans.vue?vue&type=script&lang=js"
export * from "./PricingPlans.vue?vue&type=script&lang=js"

import "./PricingPlans.vue?vue&type=style&index=0&id=e76ceda8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e76ceda8"]])

export default __exports__